import { useAuth } from "@/auth/auth.ts";
import useSWR from "swr";
import { APIError, Limrun } from "@limrun/api";

export function useAndroidInstances({
	states,
	startingAfter,
	endingBefore,
	enabled = true,
}: {
	states: string[] | "all" | undefined;
	startingAfter?: string;
	endingBefore?: string;
	enabled?: boolean;
}): {
	data: Limrun.AndroidInstancesItems | "loading";
	error?: APIError;
} {
	const auth = useAuth();
	const state = states ? (states === "all" ? "all" : states.join(",")) : undefined;
	const { data, error } = useSWR(
		enabled ? 'androidInstances' + state : null,
		async () => {
			return auth.regionClient.androidInstances.list({
				...(startingAfter ? { startingAfter } : {}),
				...(endingBefore ? { endingBefore } : {}),
				...(state === "all" || state === undefined ? {} : { state })
			});
		},
	);
	return { 
		data: data ?? "loading",
		error,
	 };
}

export function useIosInstances({
	states,
	startingAfter,
	endingBefore,
	enabled = true,
}: {
	states: string[] | "all" | undefined;	startingAfter?: string;
	endingBefore?: string;
	enabled?: boolean;
}): {
	data: Limrun.IosInstancesItems | "loading";
	error?: APIError;
} {
	const auth = useAuth();
	const state = states ? (states === "all" ? "all" : states.join(",")) : undefined;
	const { data, error } = useSWR(
		enabled ? 'iosInstances' + state : null,
		async () => {
			return auth.regionClient.iosInstances.list({
				...(startingAfter ? { startingAfter } : {}),
				...(endingBefore ? { endingBefore } : {}),
				...(state === "all" || state === undefined ? {} : { state })
			});
		},
	);
	return { 
		data: data ?? "loading",
		error,
	 };
}
